import React, { useEffect, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

export default function KnowUs() {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const headerControls = useAnimation();
  const controls1 = useAnimation();
  const controls2 = useAnimation();
  const controls3 = useAnimation();

  const { ref, inView } = useInView({ threshold: 0.2, triggerOnce: true });

  useEffect(() => {
    const runSequence = async () => {
      if (inView && isDesktop) {
        // Animate header
        await headerControls.start({
          y: 0,
          opacity: 1,
          transition: { duration: 0.6 },
        });

        // Animate cards sequentially
        await controls1.start({
          y: 0,
          opacity: 1,
          transition: { duration: 0.6 },
        });
        await controls2.start({
          y: 0,
          opacity: 1,
          transition: { duration: 0.6 },
        });
        await controls3.start({
          y: 0,
          opacity: 1,
          transition: { duration: 0.6 },
        });
      }
    };

    runSequence();
  }, [inView, isDesktop, headerControls, controls1, controls2, controls3]);

  const cardInitial = isDesktop ? { y: 50, opacity: 0 } : {};
  const cardAnimate = isDesktop ? undefined : { y: 0, opacity: 1 };
  const headerInitial = isDesktop ? { y: -30, opacity: 0 } : {};
  const headerAnimate = isDesktop ? headerControls : { y: 0, opacity: 1 };

  return (
    <div className="row py-md-5 py-2 mx-3_5-0" ref={ref}>
      {/* HEADER */}
      <motion.div
        className="col-12 px-3"
        initial={headerInitial}
        animate={headerAnimate}
      >
        <h2 className="about-heading">Get to Know Us Better</h2>
      </motion.div>

      {/* CARD 1 */}
      <motion.div
        className="col-md-4 col-12 pe-md-5 ps-md-3 px-3"
        initial={cardInitial}
        animate={isDesktop ? controls1 : cardAnimate}
      >
        <label className="know-us-num-label">01.</label>
        <h3 className="know-us-num-h3">Find Out What Makes Us Special</h3>
        <p className="know-us-num-p">
          Our primary differentiating quality is our competitiveness and
          responsiveness to shifting market circumstances. Our key priorities
          include delivering the finest solutions at competitive prices,
          ensuring client satisfaction, and adapting to technological changes.
        </p>
      </motion.div>

      {/* CARD 2 */}
      <motion.div
        className="col-md-4 col-12 know-us-border pt-6-0 px-md-4 px-3"
        initial={cardInitial}
        animate={isDesktop ? controls2 : cardAnimate}
      >
        <label className="know-us-num-label">02.</label>
        <h3 className="know-us-num-h3">Our Journey of Growth and Impact</h3>
        <p className="know-us-num-p">
          We have begun to provide USA-based clients with diverse managed
          services. The main reason for our rapid growth is our capability and
          flexibility in response to global market changes. As a result, we now
          have satisfied customers in more than ten countries, which is
          continuously growing.
        </p>
      </motion.div>

      {/* CARD 3 */}
      <motion.div
        className="col-md-4 col-12 pt-12-0 ps-md-5 pe-md-3 px-3"
        initial={cardInitial}
        animate={isDesktop ? controls3 : cardAnimate}
      >
        <label className="know-us-num-label">03.</label>
        <h3 className="know-us-num-h3">People-First Culture</h3>
        <p className="know-us-num-p">
          It is a well-known fact that the success of every company is inherent
          in its employees. Similarly, the success of SprigStack is due to our
          most competent team. We are really fortunate to have an experienced
          team. As a result, the working environment is regarded as the best for
          encouraging innovation and creativity.
        </p>
      </motion.div>
    </div>
  );
}
